import { Epic } from 'interfaces/middleware'
import { filterRequestOfType } from 'rxOperators/filterRequestOfType'
import { MEETINGS_LIST_REQUEST, meetingsListRequestActionCreator } from 'components/features/coaching/advisorStore/actions/advisorPageActions'
import { mergeMap, map } from 'rxjs/operators'
import { ADVISOR_MEETINGS_URL } from 'interfaces/ajax'
import { of } from 'rxjs'
import { catchAjaxSafe } from 'rxOperators/catchSafe'
import { normalize } from 'helpers/normalizeHelpers'


export const meetingsListRequestEpic: Epic = (action$, _, { get }) => action$.pipe(
  filterRequestOfType(MEETINGS_LIST_REQUEST, 'request'),
  mergeMap(({ payload }) => {
    const { params } = payload

    return get(ADVISOR_MEETINGS_URL).pipe(
      map(({ response }) => {
        const advisors = response.map((meeting) => meeting.advisor)
        const meetings = response.map((meeting) => {
          const { advisor, ...restMeeting } = meeting
          return {
            ...restMeeting,
            advisorUid: advisor.uid,
          }
        })

        return meetingsListRequestActionCreator.success(params, {
          advisors: normalize(advisors, 'uid'),
          meetings: normalize(meetings, 'uid'),
        })
      }),
      catchAjaxSafe((error) => of(meetingsListRequestActionCreator.error(params, error.status)))
    )
  }),
)
